// removed by extract-text-webpack-plugin
module.exports = {"cls1":"_1rYap","cls2":"_2EubI","cls3":"_3LQsL"};